/**
 * Global Logger Module
 * 
 * This module is bundled separately by Vite and made available globally
 * to prevent circular dependency issues. It's completely self-contained.
 */

// Simple environment detection without any imports
const isDev = typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || 
   window.location.hostname === '127.0.0.1' ||
   window.location.protocol === 'file:');

// Create logger function
function createLogger(prefix = '', showSource = false) {
  if (!isDev) {
    // Production: return no-op functions
    return {
      blue: () => {},
      red: () => {},
      green: () => {},
      yellow: () => {},
      purple: () => {},
      log: () => {},
      table: () => {}
    };
  }

  // Development: full logger
  const { log, table, error, warn } = console;

  function style(color) {
    return color ? `font-weight: bold; color: #fff; background: ${color}; padding: .25em .5em; text-shadow: 1px 1px rgba(0,0,0,.3); border-radius: 3px;` : '';
  }
  
  function processError(err) {
    try {
      const splitErr = [...err.stack.split('\n')].filter((i) => (!i.includes("Error") && !i.includes("logger.js")))[0].split('/');
      return splitErr[splitErr.length - 1];
    } catch {
      return '';
    }
  }
  
  function processLog(args, color, logFn = log) {
    const line = showSource ? `[${processError(new Error())}]` : '';
    const logged = [`%c${prefix ? `${prefix} ` : ''}${typeof args[0] === 'string' ? args.shift() : ''}`, color, ...args, line ? line : ''];
    return logFn.apply(console, logged);
  }
  
  return {
    blue: (...args) => processLog(args, style("dodgerblue")),
    red: (...args) => processLog(args, style("tomato"), error),
    green: (...args) => processLog(args, style("forestgreen")),
    yellow: (...args) => processLog(args, style("goldenrod"), warn),
    purple: (...args) => processLog(args, style("rebeccapurple")),
    log: (...args) => processLog(args, style('')),
    table: (...args) => table.apply(console, args)
  };
}

// Export the logger factory
export const Log = createLogger;

// Export a default logger
export const logger = createLogger('app');

// Make logger globally available to prevent import issues
if (typeof window !== 'undefined') {
  window.Log = Log;
  window.logger = logger;
}
